import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import MagnetGrid from "components/organisms/magnets/MagnetGrid";
import PlaceHolderButton from "components/atoms/buttons/PlaceHolderButton";
import { Helmet } from "react-helmet-async";
import { ROUTES } from "../../constants";
import BrandDashboardHeader from "./BrandDashboardHeader";
import MagnetDetails from "../MagnetDetails";
import CreateMagnetModal from "./CreateMagnetModal";

type Props = {
  brandWithMagnets: BrandWithMagnets;
};
function RightSideContent({ brandWithMagnets }: Props) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isCreateMagnetModalOpen, setIsCreateMagnetModalOpen] = useState(false);

  const magnetFromUrl = searchParams.get("m");

  const handleCreateMagnet = (magnetType: MagnetProgramTypes) => {
    navigate(magnetType === 1 ? ROUTES.CREATE_CONTROLLED_MAGNET_ROUTE : ROUTES.CREATE_PUBLIC_MAGNET_ROUTE);
  };

  const handleCreateMagnetButtonClick = () => {
    setIsCreateMagnetModalOpen(true);
  };

  const { magnets, ...brand } = brandWithMagnets;

  const renderRightSideContent = () => {
    if (magnetFromUrl) {
      return <MagnetDetails />;
    }
    return (
      <>
        <Helmet>
          <title>Brand Dashboard - MAGNETIQ</title>
        </Helmet>

        <CreateMagnetModal
          handleCreateMagnet={handleCreateMagnet}
          open={isCreateMagnetModalOpen}
          onClose={() => setIsCreateMagnetModalOpen(false)}
        />

        <BrandDashboardHeader
          handleCreateMagnet={handleCreateMagnetButtonClick}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...brand}
        />
        {magnets.length ? (
          <MagnetGrid magnets={magnets} />
        ) : (
          <PlaceHolderButton
            label="Start by creating your first Magnet"
            handleOnClick={handleCreateMagnetButtonClick}
            additionalClasses="h-56 text-white"
          />
        )}
      </>
    );
  };

  return <div className="mr-5 justify-center space-y-5">{renderRightSideContent()}</div>;
}
export default RightSideContent;
